// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  CommandLocation,
  CommandTarget,
  CommandType,
} from "./types";


export default __t.row({
  sessionId: __t.u64().name("session_id"),
  sourcePresenceId: __t.u64().name("source_presence_id"),
  targetPresenceId: __t.option(__t.u64()).name("target_presence_id"),
  get commandType() {
    return CommandType.name("command_type");
  },
  twinIds: __t.array(__t.string()).name("twin_ids"),
  propertyNames: __t.array(__t.string()).name("property_names"),
  latitude: __t.option(__t.f64()),
  longitude: __t.option(__t.f64()),
  altitude: __t.option(__t.f64()),
  durationMs: __t.option(__t.u32()).name("duration_ms"),
  message: __t.option(__t.string()),
  createdAt: __t.timestamp().name("created_at"),
  get flyTarget() {
    return __t.option(CommandTarget).name("fly_target");
  },
  get lookAtTarget() {
    return __t.option(CommandTarget).name("look_at_target");
  },
  lookAtBlendStart: __t.option(__t.f32()).name("look_at_blend_start"),
  distance: __t.option(__t.f32()),
  pitch: __t.option(__t.f32()),
  rotateSpeed: __t.option(__t.f32()).name("rotate_speed"),
  opacity: __t.option(__t.f32()),
  get path() {
    return __t.option(__t.array(CommandLocation));
  },
  cameraMode: __t.option(__t.string()).name("camera_mode"),
  telemetryNames: __t.option(__t.array(__t.string())).name("telemetry_names"),
});
